export default __webpack_public_path__ + "static/media/pexels-uriel-mont-6280613.56c3b8cf.jpg";